export type EnvironmentMode = 'development' | 'staging' | 'interop' | 'production'

export const ENVIRONMENT_MODES = ['development', 'staging', 'interop', 'production'] as const satisfies readonly EnvironmentMode[]

export function isEnvironmentMode(value: string): value is EnvironmentMode {
  return (ENVIRONMENT_MODES as readonly string[]).includes(value)
}
